// extracted by mini-css-extract-plugin
export default {"dashboardLayout":"DashboardLayout_dashboardLayout__oomEb","mainContent":"DashboardLayout_mainContent__IrwbE","content":"DashboardLayout_content__xw5fM"};